import { CustomMode } from './printingAreas';
import {
  SINGLE_CMYK,
  DOUBLE_CMYK,
  FULL_CUSTOM_CMYK,
  FULL_CUSTOM_TOP_CMYK,
  SINGLE_SCREEN_PRINTING,
  DOUBLE_SCREEN_PRINTING,
  FULL_CUSTOM_SCREEN_PRINTING,
} from '../../utils/Variables';

export const CustomProductId = Object.freeze({
  SINGLE_CMYK,
  DOUBLE_CMYK,
  FULL_CUSTOM_CMYK,
  FULL_CUSTOM_TOP_CMYK,
  SINGLE_SCREEN_PRINTING,
  DOUBLE_SCREEN_PRINTING,
  FULL_CUSTOM_SCREEN_PRINTING,
});

export const CustomModeMap = Object.freeze({
  [CustomProductId.SINGLE_CMYK]: CustomMode.SINGLE,
  [CustomProductId.DOUBLE_CMYK]: CustomMode.DOUBLE,
  [CustomProductId.FULL_CUSTOM_CMYK]: CustomMode.FULL_CUSTOM,
  [CustomProductId.FULL_CUSTOM_TOP_CMYK]: CustomMode.FULL_CUSTOM_TOP,
  [CustomProductId.SINGLE_SCREEN_PRINTING]: CustomMode.SINGLE,
  [CustomProductId.DOUBLE_SCREEN_PRINTING]: CustomMode.DOUBLE,
  [CustomProductId.FULL_CUSTOM_SCREEN_PRINTING]: CustomMode.FULL_CUSTOM,
});
